import { BackButton } from "../components/backButton.jsx";
import { HeadLogo } from "../components/headLogo.jsx";
import { useState } from "react";

function ForgotPasswordView({ onResetRequest }) {
  const [email, setEmail] = useState("");

  function handleSubmitACB() {
    if (!email.trim()) return alert("Please enter a valid email.");
      console.log("Submitting reset for:", email);

    onResetRequest(email.trim());
  }

  return (
    <div className="centerView">
      <HeadLogo />
      <BackButton />
      <div className="container">
        <div className="header">Forgot Password</div>
        <div className="getstarted">
          Enter your email and we’ll send you a password reset link.
        </div>

        <div className="signupinputs">
          <div>
            <input
              className="emailinput"
              type="email"
              placeholder="Enter your email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>
        </div>
      </div>
      <div>
        <button className="signup-login-button" onClick={handleSubmitACB}>
          Send Link
        </button>
      </div>
    </div>
  );
}

export { ForgotPasswordView };
